import { render, staticRenderFns } from "./ActionChat.vue?vue&type=template&id=01f36b2f"
import script from "./ActionChat.vue?vue&type=script&lang=js"
export * from "./ActionChat.vue?vue&type=script&lang=js"
import style0 from "./ActionChat.vue?vue&type=style&index=0&id=01f36b2f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports